import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useRef } from 'react';
import classnames from 'classnames';
import { keyboardMatches, keyboardKeys } from '@hh.ru/magritte-common-keyboard';
import { Cell } from '@hh.ru/magritte-ui-cell';
import { CheckableCardElement } from '@hh.ru/magritte-ui-checkable-card/CheckableCardElement';
import { Radio, Checkbox } from '@hh.ru/magritte-ui-checkbox-radio';
import { CheckOutlinedSize24 } from '@hh.ru/magritte-ui-icon/icon';
import { Text } from '@hh.ru/magritte-ui-typography';

var styles = {"select-option-label":"magritte-select-option-label___bYo2l_10-0-15","selectOptionLabel":"magritte-select-option-label___bYo2l_10-0-15","select-option-label_desktop":"magritte-select-option-label_desktop___bceen_10-0-15","selectOptionLabelDesktop":"magritte-select-option-label_desktop___bceen_10-0-15","select-delimiter":"magritte-select-delimiter___WyeR6_10-0-15","selectDelimiter":"magritte-select-delimiter___WyeR6_10-0-15"};

const CheckableComponent = ({ type, value, checked, name, onChange, 'data-qa': dataQa, }) => {
    if (type === 'label') {
        return (jsxs("span", { children: [checked && jsx(CheckOutlinedSize24, {}), jsx("input", { type: "hidden", name: name, value: value.value })] }));
    }
    if (type === 'radio') {
        return (jsx(Radio, { "data-focus-visible-skip": "true", "data-qa": dataQa, tabIndex: -1, name: name, value: value.value, checked: checked, onChange: (event) => {
                onChange(value, event.target.checked);
            } }));
    }
    return (jsx(Checkbox, { "data-focus-visible-skip": "true", "data-qa": dataQa, tabIndex: -1, name: name, value: value.value, checked: checked, onChange: (event) => {
            onChange(value, event.target.checked);
        } }));
};
CheckableComponent.displayName = 'SelectInputRender';
const SelectOption = ({ checked, name, disabled, render, type, onChange, plain, isMobile = true, data, multiple, isXS, 'data-qa': dataQa, }) => {
    const [focusVisible, setFocusVisible] = useState(false);
    const focusedByMouseRef = useRef(false);
    const input = CheckableComponent({ type, value: data, checked, name, onChange, 'data-qa': dataQa });
    const renderProps = {
        data,
        checked,
        multiple,
        name,
        onChange,
        input,
        type,
        plain,
        disabled,
        render,
        isXS,
    };
    if (type === 'delimiter') {
        return (jsx("div", { className: classnames({ [styles.selectDelimiter]: !plain }), children: jsx(Text, { typography: "label-3-regular", children: render(renderProps) }) }));
    }
    if (plain) {
        return (jsx("div", { className: classnames(styles.selectOptionLabel, { [styles.selectOptionLabelDesktop]: !isMobile }), children: jsx(Cell, { align: "center", "data-qa": `magritte-select-option-${data.value}`, "data-magritte-select-option": data.value, right: type === 'label' ? input : undefined, vertPadding: isMobile, disabled: disabled, onClick: () => {
                    onChange(data, !checked);
                }, children: render(renderProps) }) }));
    }
    return (jsx(CheckableCardElement, { Element: "label", padding: 16, borderRadius: 12, flexible: false, checked: checked, "data-magritte-select-option": data.value, focusVisible: focusVisible, "data-qa": `magritte-select-option-${data.value}`, disabled: disabled, toneHover: true, onClick: () => {
            if (!plain && type === 'label') {
                onChange(data, !checked);
            }
        }, onMouseDown: () => {
            focusedByMouseRef.current = true;
        }, onKeyDown: (event) => {
            if (keyboardMatches(event.nativeEvent, [keyboardKeys.Enter, keyboardKeys.Space])) {
                onChange(data, !checked);
                event.preventDefault();
                setFocusVisible(true);
            }
        }, onFocus: (event) => {
            if (!event.target.dataset.focusVisibleSkip) {
                return;
            }
            if (focusedByMouseRef.current) {
                focusedByMouseRef.current = false;
                return;
            }
            setFocusVisible(true);
        }, onBlur: () => {
            if (focusVisible) {
                setFocusVisible(false);
            }
        }, children: render(renderProps) }));
};

export { SelectOption };
//# sourceMappingURL=SelectOption.js.map
